
import { defineComponent, onBeforeMount, ref } from 'vue';
// import { SearchIcon, XIcon } from 'vue-feather-icons';
// import axios, { AxiosError } from 'axios';
import moment from 'moment';
// eslint-disable-next-line object-curly-newline
import { invokegetOperationData, invokeDeleteLearnerJourney, updateLearnerRecord, invokegetSkillProf, invokeAssignProxyToPlagiarizedLearners, invokeHoldLearnerJourney } from '@/utils/admin/operation_service';
import { invokeGetUserRole } from '@/utils/admin/master_service';
// eslint-disable-next-line
import router from '@/router';
import { getPreSignedUrl, uploadSubmission } from '@/utils/learner_submit_service';
import { invokeGetProxyList } from '@/utils/admin/assign_proxy_service';
import axios, { AxiosError } from 'axios';

export default defineComponent({
  name: 'OperationalTab',
  // components: { SearchIcon, XIcon },
  setup() {
    const learnerData = ref();
    const skills = ref();
    const proficiency = ref();
    const programme = ref();
    const status = ref();
    const renderReady = ref(true);
    const showOperationTab = ref(false);
    const showDeleteBtn = ref(false);
    const isShowCancel = ref(false);
    const checkOne = ref([]);
    const journeyBtnShow = ref(false);
    const showEventBtn = ref(false);
    const showGradBtn = ref(false);
    const showUploadBtn = ref(false);
    const learnerTaskId = ref();
    const userRole = ref();
    const showScreen = ref(true);
    const ohrEmail = ref();
    const showdiffAccess = ref(false);
    const showTaskImport = ref(false);
    const showReEvaluatePanel = ref(false);
    const showProficiency = ref(false);
    const diffAccess = ref();
    const learnerSubmissionFile = ref();
    const learnerSubmission = ref();
    const errorMessage = ref();
    const successMessage = ref();
    const preSignedUrl = ref();
    const selectedSkill = ref('Select Skill');
    const selectedProficiency = ref('Select Proficiency');
    const submitFilterData = {};
    const showPlagiarismBtn = ref(false);
    const proxyAssignedBtn = ref(false);
    const checkedSkill = ref();
    const checkedProficiency = ref();
    const proxyList = ref();
    const learnerOHR = ref();
    const selectedProxyOhr = ref([]);
    const showSuccessMessage = ref(false);
    const resMessage = ref();
    const showErrorMessage = ref(false);
    const linkedTaskId = ref();
    const holdLearnerBtn = ref(false);
    const learnerHoldPanel = ref(false);
    const isLearnerOnHold = ref(false);
    const learnerHoldReason = ref('');
    // const noData = ref();
    const checkedOne = () => {
      checkOne.value = [];
    };
    const proxyCheckedOne = () => {
      selectedProxyOhr.value = [];
    };

    const showLearnerHoldPanel = () => {
      learnerHoldPanel.value = !learnerHoldPanel.value;
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showJourneyBtn = (event: any, taskId: any, journeyTaskId: any, taskStatus: any, isPlagiarised: any, skill: any, level: any, ohr: any, technicalHold: any, reasonForHold: any) => {
      const cb = event.target.checked;
      if (cb === true) {
        showReEvaluatePanel.value = false;
        journeyBtnShow.value = true;
        showEventBtn.value = true;
        showGradBtn.value = true;
        showUploadBtn.value = true;
        holdLearnerBtn.value = true;
        learnerTaskId.value = taskId;
        checkedSkill.value = skill;
        learnerOHR.value = ohr;
        isLearnerOnHold.value = technicalHold === 1;
        learnerHoldReason.value = technicalHold === 1 ? reasonForHold : '';
        checkedProficiency.value = level;
        linkedTaskId.value = journeyTaskId;
        console.log(`Learner OHR ${learnerOHR.value}`);
        localStorage.setItem('inputValue', ohrEmail.value);
        if (taskStatus === 'Registered' && userRole.value.includes('System Admin')) {
          showDeleteBtn.value = true;
        } else {
          showDeleteBtn.value = false;
        }
        if (isPlagiarised === true) {
          showPlagiarismBtn.value = true;
        } else {
          showPlagiarismBtn.value = false;
        }
      } else {
        journeyBtnShow.value = false;
        holdLearnerBtn.value = false;
        isLearnerOnHold.value = false;
        showEventBtn.value = false;
        showDeleteBtn.value = false;
        showGradBtn.value = false;
        showPlagiarismBtn.value = false;
        showReEvaluatePanel.value = false;
      }
    };
    const viewLearnerDetails = () => {
      const routeData = router.resolve({ name: 'SolidifyAdministrationOperationalDetails', query: { learner_task_id: learnerTaskId.value } });
      window.open(routeData.href, '_blank');
      // router.push({ path: 'administration/OperationalTabDetails', query: { learner_task_id: learnerTaskId.value } });
    };
    const uploadLearnerSubmission = () => {
      const routeData = router.resolve({ name: 'SolidifyAdministrationUploadSubmission', query: { linked_task_id: linkedTaskId.value, learner_task_id: learnerTaskId.value } });
      window.open(routeData.href, '_blank');
      // router.push({ path: 'administration/uploadSubmission', query: { linked_task_id: linkedTaskId.value, learner_task_id: learnerTaskId.value } });
    };
    const viewEvents = () => {
      const routeData = router.resolve({ name: 'SolidifyAdministrationLearnerEvents', query: { learner_task_id: learnerTaskId.value } });
      window.open(routeData.href, '_blank');
      // router.push({ path: 'administration/learnerevents', query: { learner_task_id: learnerTaskId.value } });
    };
    const viewGrades = () => {
      const routeData = router.resolve({ name: 'SolidifyAdministrationLearnerGrades', query: { learner_task_id: learnerTaskId.value } });
      window.open(routeData.href, '_blank');
      // router.push({ path: 'administration/Learnergrades', query: { learner_task_id: learnerTaskId.value } });
    };
    const getSkillandProf = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const dataRes: any = await invokegetSkillProf('/getAllSkillProf');
      skills.value = dataRes.skill;
      proficiency.value = dataRes.proficiency;
      renderReady.value = true;
    };
    const getLearnerData = async () => {
      try {
        showReEvaluatePanel.value = false;
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const dataRes: any = await invokegetOperationData('/getAllOperationData', submitFilterData);
        learnerData.value = dataRes.operationData;
        diffAccess.value = dataRes.diffStatus;
        console.log('diffAccess.value', diffAccess.value);
        if (diffAccess.value) {
          showdiffAccess.value = true;
        }
        if (learnerData.value) {
          for (let index = 0; index < learnerData.value.length; index += 1) {
            const res = learnerData.value[index];
            if (res.registration_date) {
              res.registration_date = moment(res.registration_date).format('DD-MM-YYYY');
            }
            if (res.completion_date) {
              res.completion_date = moment(res.completion_date).format('DD-MM-YYYY');
            }
            if (res.submission_date) {
              res.submission_date = moment(res.submission_date).format('DD-MM-YYYY');
            }
          }
        }
        localStorage.removeItem('inputValue');

        renderReady.value = true;
      } catch (error) {
        console.log(error);
      }
    };
    const searchData = async () => {
      if (ohrEmail.value) {
        Object.assign(submitFilterData, { ohrEmail: ohrEmail.value });
        await getLearnerData();
      }
    };
    const DeleteLearnerDetails = async () => {
      renderReady.value = false;
      await invokeDeleteLearnerJourney(`/deleteRegisteredLearner/${learnerTaskId.value}`);
      await getLearnerData();
      renderReady.value = true;
    };
    const clearInput = () => {
      ohrEmail.value = '';
      isShowCancel.value = false;
    };
    const showHideCancel = () => {
      if (!ohrEmail.value) isShowCancel.value = false;
      else isShowCancel.value = true;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectedFile = async (event: any) => {
      try {
        // eslint-disable-next-line prefer-destructuring
        const file = event.target.files[0];
        const fileName = event.target.files[0].name;

        const fileSize = event.target.files[0].size / 1024 / 1024;

        if (fileSize > 200) {
          errorMessage.value = 'fileSize greater than 200 MB';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        } else {
          learnerSubmissionFile.value = file;
          learnerSubmission.value = fileName;
        }
      } catch (error) {
        console.log(error);
      }
    };
    const submitSubmiision = async () => {
      if (learnerSubmission.value) {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const resPresSigned: any = await getPreSignedUrl('/v1/pretAuthUrlForUploadLearner', {
          file_name: learnerSubmission.value,
          learner_task_id: learnerTaskId.value,
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const preSignedRes: any = resPresSigned.data;
        preSignedUrl.value = preSignedRes.preSignedUrl;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const uploadedRes: any = await uploadSubmission(preSignedUrl.value, learnerSubmissionFile.value);
        console.log('Upload Response', uploadedRes);
        if (uploadedRes.status === 200) {
          const data = {
            learner_submission: learnerSubmission.value,
            learner_task_id: learnerTaskId.value,
          };
          // renderReady.value = false;
          const updateRes = await updateLearnerRecord('/uploadLearnerSubmissionFromAdmin', data);
          console.log(updateRes);
          successMessage.value = 'File uploaded Successfully';
          setTimeout(() => {
            successMessage.value = null;
            showTaskImport.value = false;
            getLearnerData();
          }, 6000);
        } else {
          errorMessage.value = 'There is issue in the file upload';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
        }
        renderReady.value = true;
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProficiency = async (e: any) => {
      selectedProficiency.value = e.target.value;
      if (selectedProficiency.value === 'Select Proficiency') {
        selectedProficiency.value = 'Select Proficiency';
        Object.assign(submitFilterData, { proficiency_id: '' });
      } else {
        Object.assign(submitFilterData, { proficiency_id: selectedProficiency.value });
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedSkill = async (e: any) => {
      // console.log(e.target.removeAttr('selected'));
      selectedSkill.value = e.target.value;
      if (selectedSkill.value === 'Select Skill') {
        selectedSkill.value = 'Select Skill';
        showProficiency.value = false;
        Object.assign(submitFilterData, { skill_id: '', proficiency_id: '' });
      } else {
        Object.assign(submitFilterData, { skill_id: selectedSkill.value });
        showProficiency.value = true;
      }
    };
    const showProxy = async () => {
      renderReady.value = false;
      showReEvaluatePanel.value = true;
      proxyList.value = await invokeGetProxyList('/getAllProxyBySkill', checkedSkill.value);
      renderReady.value = true;
      console.log('Proxy List', proxyList.value);
    };
    const assignLearnerToProxy = async () => {
      console.log('Assign Proxy');
      try {
        renderReady.value = false;
        const data = {
          learner: learnerTaskId.value,
          proxy_key: selectedProxyOhr.value[0],
          learner_key: learnerOHR.value,
          skill: checkedSkill.value,
          proficiency: checkedProficiency.value,
        };
        console.log('Selected Data', data);
        const assignProxyRes = await invokeAssignProxyToPlagiarizedLearners('/reevaluatePlagiarism', data);
        showReEvaluatePanel.value = false;
        renderReady.value = true;
        console.log('assignProxyRes?.data.message', assignProxyRes?.data.message);
        resMessage.value = assignProxyRes?.data.message;
        showSuccessMessage.value = true;
        setTimeout(() => {
          showSuccessMessage.value = false;
        }, 6000);
        await getLearnerData();
        //   console.log('data ohr', assignProxyRes);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log('err.response?.data', err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 6000);
        }
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const callHoldLearner = async () => {
      renderReady.value = false;
      const data = {
        learner_task_id: learnerTaskId.value,
        action: !isLearnerOnHold.value === true ? '1' : '0',
        reason: learnerHoldReason.value,
      };
      try {
        const res = await invokeHoldLearnerJourney('/admin/learner/perform_technical_hold', data);
        console.log(res);
        successMessage.value = res;
        isLearnerOnHold.value = !isLearnerOnHold.value;
        setTimeout(() => {
          successMessage.value = null;
          getLearnerData();
        }, 6000);
        renderReady.value = true;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log('err.response?.data', err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 6000);
        }
      }
      learnerHoldPanel.value = false;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showAssignProxyBtn = async (event: any) => {
      const proxyOhr = event.target.checked;
      if (proxyOhr === true) {
        proxyAssignedBtn.value = true;
      } else {
        proxyAssignedBtn.value = false;
      }
    };
    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        if (userRole.value.includes('System Admin') || userRole.value.includes('System Admin View Access') || userRole.value.includes('Program Admin')) {
          console.log('inside Role');
          showScreen.value = true;
          await getSkillandProf();
        } else {
          showScreen.value = false;
        }
      }
      // if (userRole.value.includes('System Admin View Access')) {
      //   showDeleteBtn.value
      // }
      if (localStorage.getItem('inputValue')) {
        ohrEmail.value = localStorage.getItem('inputValue');
        Object.assign(submitFilterData, { ohrEmail: localStorage.getItem('inputValue') });
        await getLearnerData();
      }
    });
    return {
      learnerData,
      skills,
      proficiency,
      programme,
      status,
      showOperationTab,
      renderReady,
      checkOne,
      checkedOne,
      showJourneyBtn,
      journeyBtnShow,
      viewLearnerDetails,
      ohrEmail,
      searchData,
      showDeleteBtn,
      DeleteLearnerDetails,
      isShowCancel,
      clearInput,
      showHideCancel,
      showEventBtn,
      viewEvents,
      showGradBtn,
      viewGrades,
      showScreen,
      showdiffAccess,
      diffAccess,
      showUploadBtn,
      submitSubmiision,
      showTaskImport,
      selectedFile,
      preSignedUrl,
      successMessage,
      errorMessage,
      getSkillandProf,
      getSelectedSkill,
      selectedProficiency,
      selectedSkill,
      getSelectedProficiency,
      showProficiency,
      showPlagiarismBtn,
      showReEvaluatePanel,
      checkedSkill,
      showProxy,
      proxyList,
      proxyAssignedBtn,
      assignLearnerToProxy,
      selectedProxyOhr,
      showAssignProxyBtn,
      showSuccessMessage,
      resMessage,
      showErrorMessage,
      proxyCheckedOne,
      linkedTaskId,
      uploadLearnerSubmission,
      holdLearnerBtn,
      learnerHoldPanel,
      showLearnerHoldPanel,
      callHoldLearner,
      isLearnerOnHold,
      learnerHoldReason,
      // noData,
    };
  },
});
